import React from 'react';
import Navbar from '../../../components/Navbar';
import Header from '../../../components/Header';
import Section from './components';

const HistoriKum = () => (
  <>
    <Navbar />
    <Header />
    <Section />
  </>
);

export default HistoriKum;
